import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import { IFlightSearchRequestForm } from '@jetslash/market-frontend-shared-core/src/forms/flightSearchRequest';

import FlightSearchRequestForm from '@/components/forms/FlightSearchRequestForm';

import FlightSearchRouteHelper
  from "@jetslash/market-frontend-shared-core/src/utilities/flightSearch/FlightSearchRouteHelper";
import styles from './FlightSearchFormOverlay.module.scss';

interface IProps {
  transparent?: boolean;
  initialFormValues?: any;
}

const FlightSearchFormOverlay: FunctionComponent<IProps> = ({ transparent = false, initialFormValues = null }) => {
  const router = useRouter();
  const flightSearchRequestCallback = (flightSearchRequestFormValues: IFlightSearchRequestForm, requestId: string) => {
    // The requestId is an encoded version of the form
    router.push(FlightSearchRouteHelper.generateResultsPath(requestId));
  };

  return (
    <div
      className={classNames(styles.container, {
        [`${styles.transparent}`]: transparent,
      })}
    >
      <FlightSearchRequestForm
        initialFormValues={initialFormValues}
        flightSearchRequestCallback={flightSearchRequestCallback}
      />
    </div>
  );
};

export default FlightSearchFormOverlay;
